module.exports = __webpack_public_path__ + "static/media/gpay.bd603900.png";